



































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderBox from '@/components/HeaderBox.vue'
import ReviewTraces from '@/components/ReviewTraces.vue'
import CbsReportReview from '@/components/CbsReportReview.vue'
import CarInfo from '@/components/carDetail/CarInfo.vue'

@Component({
  components: {
    HeaderBox,
    ReviewTraces,
    CbsReportReview,
    CarInfo
  }
})
export default class carDetail extends Vue {
  videoDialogVisible: boolean = false
  popoverVisible: boolean = false

  procedure: any = {}
  basicInfo = {}
  inspectionInfo: any = {}
  configInfo: any = {}
  carDetail = {}
  cbsOrder = {}
  otherInfo = {}
  historyCbsOrder = {}
  cbsReportUrl: any = ''
  cbsReviewVisible = false
  reviewTraces = []
  carInfoImages = []

  mounted () {
    const { center_car_id, auction_id } = this.$route.query;
    this.getDetail(center_car_id, auction_id);
    this.getReviewTraces(center_car_id);
  }

  async getReviewTraces (id) {
    const { code, data } = await this.$rest.carManage.getReviewTraces(id);
    if (code !== 0) return;
    this.reviewTraces = data.infos;
  }

  async getDetail (carId, auction_id) {
    const { code, data } = await this.$rest.carManage.getStockCarDetail(carId, {
      auction_id
    });
    if (code !== 0) return;
    this.carDetail = data.car_info || {};
    this.basicInfo = data.car_info.basic_info || {};
    this.configInfo = data.car_info.detail.config || {};
    this.procedure = data.car_info.detail.procedure || {};
    this.cbsOrder = data.store_cbs_order || {};
    this.historyCbsOrder = data.history_cbs_order;
    this.otherInfo = data.other_info || {};
    this.inspectionInfo = data.inspection_info || {};
    this.carInfoImages = data.car_info.images || [];
  }

  handleShowCbsReport(report_id) {
    if (!report_id) {
      return false
    }
    const { protocol, host } = window.location
    const reportUrl = this.joinTokenToUrl(`${protocol}//${host}/api/v1/car_management/cbs_report_detail?order_id=${report_id}`);
    this.cbsReportUrl = reportUrl
    this.cbsReviewVisible = true
  }

  handleGo (path, params) {
    const { href } = this.$router.resolve({ path, query: params });
    window.open(href, '_blank');
  }
}
